import React, { Component } from 'react';
import { Alert, Button } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form as ReduxForm } from 'react-redux-form';
import { translate } from 'react-i18next';

import { loginUser } from 'modules/authentication';
import { updateConfigValue } from 'modules/appConfig';
import Input from 'components/Fields/Input';

import styles from './Signin.module.scss';

class FormLogin extends Component {
  constructor (props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleSubmit () {
    this.props.loginUser(this.props.login);
  }

  handleClick () {
    this.props.updateConfigValue('hasForgotPassword', true);
  }

  render () {
    const { form, t, hasChangedPassword } = this.props;

    return (

      <div>
        {hasChangedPassword && (
          <Alert
            banner
            type="info"
            message="Vous venez de créer un nouveau mot de passe"
            description="Veuillez vous authentifier pour accéder à votre compte"
          />
        )}
        <ReduxForm model="login" onSubmit={this.handleSubmit}>
          <h2>Se connecter</h2>
          <Input
            autoFocus
            type="email"
            model=".email"
            label="Email"
            errorMessages={{ required: { message: t('empty_email') } }}
          />

          <Input
            model=".password"
            type="password"
            label="Mot de passe"
            errorMessages={{ required: { message: t('empty_password') } }}
            required
          />
          <div className={styles.button_container}>
            <Button
              className={styles.button}
              type="dashed"
              onClick={this.handleClick}
            >
          Mot de passe oublié
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              icon="arrow-right"
              className={styles.button}
              loading={form.pending}
            >
          Me connecter
            </Button>

          </div>
        </ReduxForm>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  login: state.login,
  form: state.forms.login.$form,
  hasForgotPassword: state.appConfig.hasForgotPassword,
  hasChangedPassword: state.appConfig.hasChangedPassword,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ loginUser, updateConfigValue }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(translate('error')(FormLogin));



// WEBPACK FOOTER //
// ./src/components/Signin/Signin.js